<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        :ref="searchItemConfigModule"
        :config-module="searchItemConfigModule"
        :is-collapse-list="true"
        :grid-options="gridOptions"
        :is-append-query="true"
        :reset="true"
        :lob="'IE'"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :record-expand-status="true"
        :input-enter-query="true"
        grid-config-module="170001"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      >
        <template slot="operations">
          <el-button
            :disabled="!selectedRow || hqDisabledViewDetail || (!isHQ && !validSingleSelect) || hierarchyDisabledViewDetail"
            no="look"
            type="success"
            @click="toLook()"
          >{{ $t('common.btn.look') }}</el-button>
          <el-button
            :disabled="!(selectedRow && Number(selectedRow.jobState) === 0 && !JobUtils.isBlockJob(currentRow)) || !validSingleSelect || !hierarchyValidSingleSelect"
            no="edit"
            type="success"
            @click="toEdit"
          >{{ $t('common.btn.edit') }}</el-button>
          <el-button
            v-permission="[addButtonPermission]"
            no="new"
            :disabled="hqDisabledOperate"
            type="primary"
            @click="toAdd"
          >{{ $t('common.btn.new') }}</el-button>
          <el-button
            v-show="showAddHblButton"
            v-permission="[addButtonPermission]"
            no="addHbl"
            :disabled="hqDisabledOperate"
            type="primary"
            @click="toAdd({masterFlag: true})"
          >{{ $t('SeaExport.AddHbl') }}</el-button>
          <el-button
            v-permission="[addButtonPermission]"
            no="Clone"
            :disabled="!selectedRow || !validSingleSelect || !hierarchyValidSingleSelect"
            type="primary"
            @click="toCopy"
          >{{ $t('SeaExport.Clone') }}</el-button>
          <el-button
            no="Delete"
            type="danger"
            :disabled="!validMultipleSelect"
            @click="toDelete"
          >{{ $t('SeaExport.Delete') }}</el-button>
          <el-dropdown
            v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)"
            no="exportHandle"
            :disabled="!validMultipleSelect"
            split-button
            type="primary"
            style="margin: 0 5px;"
            @click="exportHandle"
            @command="p=>{exportCommand=p;exportHandle()}"
          >
            {{ exportCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('SeaExport.ExportToExcel')"
              >{{ $t('SeaExport.ExportToExcel') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ExportWithSOPToExcel')"
              >{{ $t('SeaExport.ExportWithSOPToExcel') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button no="EditSopStatus" :disabled="!validMultipleSelect" type="primary" @click="editState">{{ $t('SeaExport.EditSopStatus') }}</el-button>
          <el-dropdown
            no="batchHandle"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary" :disabled="!batchSelectFlag || !validMultipleSelect">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchShutOut'])" :command="1">{{ $t('SeaExport.BatchShutOut') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchCommit'])" :command="2">{{ $t('SeaExport.BatchCommit') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchPerCommit'])" :command="3">{{ $t('SeaExport.BatchPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchManagerSubmission'])" :command="4">{{ $t('SeaExport.BatchManagerSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnToOperater'])" :command="5">{{ $t('SeaExport.BatchReturnPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_Retract'])" :command="6">{{ $t('SeaExport.BatchReturnSubmit') }}</el-dropdown-item>
              <el-dropdown-item
                :command="7"
              >{{ $t('SeaExport.BatchUpdateCustomJobType') }} </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockReceivable'])"
                :command="8"
              >{{ $t('SeaExport.BatchUnlockReceivableExpenses') }} </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockPayable'])"
                :command="9"
              >{{ $t('SeaExport.BatchUnlockPayableFees') }} </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockReceivable'])" :command="10">{{ $t('SeaExport.BatchLockingReceivableExpenses') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockPayable'])" :command="11">{{ $t('SeaExport.BatchLockingPayableFees') }}</el-dropdown-item>
              <el-dropdown-item :disabled="BatchModifyBusiness" :command="17">{{ $t('SeaExport.BatchModifyBusiness') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_jobSopTab_BatchReplaceTemplate'])" :command="18">{{ $t('SeaExport.ReplaceSOPTemplatesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="useOrderCenterMode&&!isRegionalCommission" :command="19">{{ $t('queryJob.BatchInitiateCollaboration') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchFillGpExplain'])" :command="20">{{ $t('SeaExport.BatchFillGpExplain') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchLockJob'])" :command="21">{{ $t('CargoMsg.Cargo_BatchServiceLocking') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchUnlockJob'])" :command="22">{{ $t('CargoMsg.Cargo_UnlockServicesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="openMutualTrustConfig" :command="23">{{ $t('SeaExport.BatchPushCharges') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnReview'])" :command="24">{{ $t('CargoMsg.Cargo_BatchReturnPreApproval') }}</el-dropdown-item>
              <!-- 指令操作按钮 -->
              <template v-for="(item, index) in instructioinBtns">
                <el-dropdown-item
                  :key="'instruction' + index"
                  :disabled="!item.allowOperate"
                  :command="'instruction,' + item.tenantInstructionUuid"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button
            v-show="$checkPermission(['button_print_batchPrint'])"
            :disabled="!batchSelectFlag"
            no="BatchPrint"
            type="primary"
            @click="onBatchPrint"
          >{{ $t('SeaExport.BatchPrint') }}</el-button> -->
          <el-dropdown
            v-show="$checkPermission(['button_print_batchPrint'])"
            no="BatchPrint"
            :disabled="!batchSelectFlag || !validMultipleSelect"
            split-button
            type="primary"
            style="margin-right: 5px;"
            @click="onBatchPrint($t('SeaExport.BatchPrint'))"
            @command="onBatchPrint"
          >
            {{ $t('SeaExport.BatchPrint') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button no="Statistics" :disabled="!validMultipleSelect" type="primary" @click="toStatistics">{{ $t('SeaExport.Statistics') }}</el-button>
          <el-dropdown
            v-show="$checkPermission(['tab_Charge_chargeView'])"
            no="chargeHandle"
            :disabled="!validMultipleSelect"
            split-button
            type="primary"
            style="margin-left: 5px;"
            @click="chargeHandle"
            @command="p=>{chargeCommand=p;chargeHandle()}"
          >
            {{ chargeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('SeaExport.AddCharges')"
              >{{ $t('SeaExport.AddCharges') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.EditCharges')"
              >{{ $t('SeaExport.EditCharges') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.DeleteCharges')"
              >{{ $t('SeaExport.DeleteCharges') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ChargeImport')"
              >{{ $t('SeaExport.ChargeImport') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid-wrapper
          config-module="170001"
          :grid-options="gridOptions"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          :wrap-text="true"
          style="width: 100%;"
          :show-row-groups="dataListDragGroup"
          :pre-column-state-callback="p => preColumnStateCallback(p)"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          @gridReady="params=>{gridApi=params.api}"
          @columnRowGroupChanged="() => { this.$refs[searchItemConfigModule].clickCollapseList() }"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="170001"
          :total="total"
          :page-count="pageCount"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="toQuery()"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 状态修改弹窗 -->
    <state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :tracking-list="stateDialog.trackingList"
      @callback="toQuery()"
    />
    <!-- 批量退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      no="shutOut"
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}？</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button
          no="HasChargeToShutOut"
          type="primary"
          @click="hasChargeShutoutHandler"
        >{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button
          no="NoChargeToShutOut"
          :style="{ display: shutOutDialog.shutOutButtonShow2 }"
          type="primary"
          @click="noHasChargeShutoutHandler"
        >{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button no="cancel" @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改自定义业务类型弹窗 -->
    <el-dialog
      v-if="customJobTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="customJobTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateCustomJobType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('SeaExport.CustomJobType')+':'">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_CutomJobType"
            filterable
            :method-params="{type: 'SE', active: true}"
            :default-value="customJobTypeDialog.customJobType"
            @parentCallBack="p=>{customJobTypeDialog.customJobType=p.value}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="customJobTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="customJobTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      no="Statistics"
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      :width="$selectByLang('360px', '445px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Slaves')" class="auto-width">
          <el-input v-model="statisticsDialog.txtSlaves" no="txtSlaves" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Master')" class="auto-width">
          <el-input v-model="statisticsDialog.txtMaster" no="txtMaster" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')" class="auto-width">
          <el-input v-model="statisticsDialog.txtCount" no="txtCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')" class="auto-width">
          <el-input v-model="statisticsDialog.txtCustomerCount" no="txtCustomerCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="20＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt20" no="txt20" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt40" no="txt40" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40HQ＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt40hq" no="txt40hq" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="45＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt45" no="txt45" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="TEU" class="auto-width">
          <el-input v-model="statisticsDialog.txtTeu" no="txtTeu" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Weight2')" class="auto-width">
          <el-input v-model="statisticsDialog.txtWeight" no="txtWeight" style="width:160px" :disabled="true" />
          <span>KGS</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Cubage')" class="auto-width">
          <el-input v-model="statisticsDialog.txtCubage" no="txtCubage" style="width:160px" :disabled="true" />
          <span>CBM</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ChargedWeight')" class="auto-width">
          <el-input v-model="statisticsDialog.txtChargeWeight" no="txtChargeWeight" style="width:160px" :disabled="true" />
          <span>M/T</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="auto-width">
          <el-input v-model="statisticsDialog.txtdesignationAgentNum" no="txtdesignationAgentNum" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" no="containShutOutJob" @change="handleStatistics(true)">{{ $t('SeaExport.ContainShutOutJob') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button no="Close" @click="statisticsDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :job="chargeSchemeBatchDialog.job"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      lob="IE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :charge-type="addChargeDetailDialog.type"
      lob="IE"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 编辑费用弹窗 -->
    <edit-charge-detail-dialog
      v-if="editChargeDetailDialog.visible"
      :visible.sync="editChargeDetailDialog.visible"
      :selected-jobs="editChargeDetailDialog.selectedJobs"
      :charge-type="editChargeDetailDialog.chargeType"
      lob="IE"
    />
    <!-- 删除费用弹窗 -->
    <delete-charge-detail-dialog
      v-if="deleteChargeDetailDialog.visible"
      :visible.sync="deleteChargeDetailDialog.visible"
      :selected-jobs="deleteChargeDetailDialog.selectedJobs"
      :charge-type="deleteChargeDetailDialog.chargeType"
      lob="IE"
    />
    <!-- SOP操作状态弹窗 -->
    <div class="sop-state-wrapper-grid">
      <sop-state-dialog
        :visible.sync="sopStateDialog.visible"
        :is-need-refresh.sync="sopStateDialog.isNeedRefresh"
        :job="currentRow"
        @handleClose="sopStateDialogClose"
      />
    </div>
    <!-- 批量修改业务弹窗 -->
    <batch-modify-business-dialog
      :visible.sync="batchModifyBusinessDialog.visible"
      :job-keys="batchModifyBusinessDialog.jobKeys"
      :job-list="batchModifyBusinessDialog.jobList"
      :lob="batchModifyBusinessDialog.lob"
      :integrated-logistics-type="integratedLogisticsType"
      @callback="batchModifyBusinessCallback"
    />
    <!-- 批量修改业务SOP模板弹窗 -->
    <change-sop-template-dialog
      :visible.sync="changeSopTemplateDialog.visible"
      lob="IE"
      :job-list="changeSopTemplateDialog.jobList"
      @reload="reload"
    />
    <!-- 批量协作弹窗 -->
    <batch-cooperation-dialog :visible.sync="batchCooperationDialog.visible" :job-list="batchCooperationDialog.jobList" :order-center-branch="orderCenterBranch" />
    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="gpExplain.jobUuids"
    />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="IE"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="list"
      @confirm="reload"
    />
    <!-- 应收应付类型选择弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeTypeDialog.visible"
      :title="$t('CargoMsg.Cargo_AddCostType')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 30px 30px;">
        <el-radio-group v-model="chargeTypeDialog.type" size="small">
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
          <el-radio :label="2">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_ARAP') }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onChargeTypeDialogConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeTypeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 同租户交叉委托窗口 -->
    <tenant-entrust-window ref="tenantEntrustWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>
import bookingTreeGridJS from './bookingTreeGrid.js'
import jobDetailIcon from '@/assets/job-detail.png'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import addChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog'
import editChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/editChargeDetailDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import URL from '@/api/urlTranslator'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import chargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import LocalStorageUtils from '@/utils/localStorageUtils'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import StateDialog from '@/components/Cargo/Job/StateDialog'

import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import DeleteChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue'
import BatchModifyBusinessDialog from '@/views/cargo/v0/SeaExport/components/booking/batchModifyBusinessDialog.vue'
import ChangeSopTemplateDialog from '@/components/Cargo/Job/booking/tabs/changeSopTemplateDialog'
import BatchCooperationDialog from '@/components/Cargo/Job/BatchCooperationDialog'
import { operateBranchIsOptional } from '@/utils/basicDataCache'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/ContainerLoadType'
import DateUtils from '@/utils/dateUtils'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { cache } from '@/utils/cacheManager'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import TenantEntrustWindow from '@/components/Cargo/Job/tenantEntrustWindow/index'

export default {
  name: 'IeBookingTreeGrid',
  components: { jobReturnReviewDialog, ChangeSopTemplateDialog, BatchModifyBusinessDialog, DeleteChargeDetailDialog, searchItem, cargoTemplateSelectorDialog, CargoAdvanceSelect, BatchCheckingWindow, chargeSchemeBatchDialog, addChargeDetailDialog, editChargeDetailDialog, sopStateDialog, StateDialog, BatchCooperationDialog, AddGpExplainDialog, cargoAgGridWrapper, TenantEntrustWindow },
  mixins: [BookingTreeGridMixin],
  props: {
    context: { type: Object, required: true },
    isQuery: { type: Boolean, default: false },
    integratedLogisticsType: { type: String, default: '' }
  },
  data() {
    return {
      notRefresh: false,
      appendQuery: false, // 追加查询
      TYPE_NAMES,
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      checkApChargeVerify: false, // 业务预提交时是否验证应付费用已全部审核
      useCheckRule: false, // 是否启用验证规则
      salesCanSeeBookingAgent: false,
      isAdvancedQuery: false, // 是否为高级查询
      useOrderCenterModes: false,
      customSearchItems: [],
      simpleFilter: {
        conditions: [],
        branchId: 0
      },
      complexFilter: {
        conditions: [],
        branchId: 0
      },
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        isSea: false,
        lob: 'IE',
        source: 'jobList',
        chargeType: null,
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      pageNum: 1,
      pageSize: 50,
      total: 0,
      pageCount: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => !!params.data,
            innerRenderer: params => {
              // const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}</span>`
            }
          }
        },
        onRowDataChanged: event => {
          // 重置（多选）选中行
          this.selectedRows = []
          this.$refs[this.searchItemConfigModule].clickCollapseList()
        },
        // 单选（勾选框或者其他列，都会触发）
        onCellFocused: (event) => {
          this.selectedRowIndex = event.rowIndex
        },
        // 多选（勾选框触发）
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          const data = event.data
          if (this.hierarchyViewList && !this.hierarchyViewDetail) {
            if (!this.matchOwnerBranch(data)) {
              return
            }
          }
          if (this.hqViewAllList) {
            const curOfficeId = this.$store.getters.currentOfficeId
            const data = event.data
            if (curOfficeId === 1) {
              if (!this.hqViewAllDetail) {
                return
              }
            } else {
              let needCheck = true
              if (!this.isZy && this.hierarchyViewDetail) {
                if (this.childOfficeIds.includes(data.opOffice) || this.childOfficeIds.includes(data.salesOffice)) {
                  needCheck = false
                }
              }
              if (needCheck) {
                if (data.opOffice !== curOfficeId && data.salesOffice !== curOfficeId && !this.mactchCooperateBranch(data.cooperatebranch, this.$store.getters.currentOffice)) {
                  return
                }
              }
            }
          }
          if (event.colDef.field === 'sopState') {
            LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', true)
            this.sopStateDialog.visible = true
            this.currentRow = data
            return
          }
          this.toLook(event.data)
        },
        getRowStyle: (params) => {
          if (!params.data) {
            return
          }
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of colorSettings) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        // {
        //   headerName: this.$t('SeaExport.BusinessNo'),
        //   colId: 'jobNo',
        //   field: 'jobNo',
        //   width: 240,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: params => !!params.data,
        //   wrapText: false
        // },
        {
          headerName: this.$t('SeaExport.Status'),
          colId: 'jobState',
          field: 'jobState',
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filter: false,
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SettlementType'),
          field: 'creditDateLimited',
          colId: 'creditDateLimited',
          hide: true,
          valueFormatter: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.value !== '') {
              return (Number(params.value) > 0 || Number(params.data.creditDateType) > 0) ? this.$t('Message.Monthly') : this.$t('Message.ByTicket')
            }
            return ''
          },
          filter: true,
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.data.creditDateLimited !== '') {
              return (Number(params.data.creditDateLimited) > 0 || Number(params.data.creditDateType) > 0) ? this.$t('Message.Monthly') : this.$t('Message.ByTicket')
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvoicingMethod'),
          field: 'creditDateType',
          colId: 'creditDateType',
          hide: true,
          valueFormatter: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.value !== '') {
              return Number(params.value) > 0 ? this.$t('CargoMsg.Cargo_LotteryDraw') : this.$t('CargoMsg.Cargo_SchoolMonth')
            }
            return ''
          },
          filter: true,
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.data.creditDateType !== '') {
              return Number(params.data.creditDateType) > 0 ? this.$t('CargoMsg.Cargo_LotteryDraw') : this.$t('CargoMsg.Cargo_SchoolMonth')
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateOpCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateSalesOffice), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDept',
          colId: 'salesDept',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateSalesDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.BusinessCreator'),
          colId: 'createdBy',
          field: 'createdBy',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 75,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            if (params.data.customerId > 0) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
            }
            return ''
          },
          filter: false,
          filterParams: {},
          width: 150
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          hide: true,
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCargoSalesId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ConsignationStatusTime'),
          colId: 'crossTenantHistoryStateDate',
          field: 'crossTenantHistoryStateDate',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'crossTenantHistoryState',
          field: 'crossTenantHistoryState',
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.crossTenantHisStateCommonFun(params.data, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          colId: 'customerRefNo',
          field: 'customerRefNo',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          colId: 'poNo',
          field: 'poNo',
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          colId: 'op',
          field: 'op',
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOpId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Sales'),
          colId: 'sales',
          field: 'sales',
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateSales), 'auto_sales')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp',
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOverseaOp), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Accrued'),
          colId: 'provisioned',
          field: 'provisioned',
          hide: true,
          cellRenderer: params => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          colId: 'csr',
          field: 'csr',
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCsrId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Documents'),
          colId: 'dc',
          field: 'dc',
          hide: true,
          cellRenderer: params => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateDcId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          colId: 'customsDate',
          field: 'customsDate',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          colId: 'customJobType',
          field: 'customJobType',
          hide: true,
          valueGetter: params => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType, 'name', SystemConstants.IE.code, false)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.OperationTips'),
          colId: 'operationTips',
          field: 'operationTips',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          colId: 'remarks',
          field: 'remarks',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          colId: 'userDefinedField1',
          field: 'userDefinedField1',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          colId: 'userDefinedField2',
          field: 'userDefinedField2',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          colId: 'userDefinedField3',
          field: 'userDefinedField3',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          colId: 'userDefinedField4',
          field: 'userDefinedField4',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'projectName',
          colId: 'projectName',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectBatch'),
          field: 'projectBatch',
          colId: 'projectBatch',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
          field: 'receivableChargeLockedStatus',
          colId: 'receivableChargeLockedStatus',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
          field: 'payableChargeLockedStatus',
          colId: 'payableChargeLockedStatus',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.ChannelNo'),
          field: 'channelNo',
          colId: 'channelNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: 'receivableChargeInput',
          colId: 'receivableChargeInput',
          width: 150,
          filter: false,
          filterParams: {},
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.chargeInputLabelFunction(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateOpDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          field: 'plannerDepartment',
          colId: 'plannerDepartment',
          hide: true,
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AirlinePerson'),
          field: 'planner',
          colId: 'planner',
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperatePlanner), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId1), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId2), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: 'preCommitUser',
          colId: 'preCommitUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: 'preCommitDate',
          colId: 'preCommitDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: 'commitUser',
          colId: 'commitUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ShutOutDate'),
          field: 'shutOutDate',
          colId: 'shutOutDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: 'submissionDate',
          colId: 'submissionDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: 'lockJobUser',
          colId: 'lockJobUser',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: 'lockJobDate',
          colId: 'lockJobDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_11') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_10') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          field: 'quantityContract',
          colId: 'quantityContract',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.numberColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          field: 'weightContract',
          colId: 'weightContract',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          field: 'cubageContract',
          colId: 'cubageContract',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          colId: 'quantityActual',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.numberColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          colId: 'weightActual',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          colId: 'cubageActual',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.LocalService'),
          field: 'loadingTerm',
          colId: 'loadingTerm',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.value)
          },
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.data.loadingTerm)
          },
          filterParams: {},
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsClassification'),
          field: 'danClassNo',
          colId: 'danClassNo',
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsUNNo'),
          field: 'danUNNo',
          colId: 'danUNNo',
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          field: 'customsBroker',
          colId: 'customsBroker',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_9') : ''
          },
          hide: true,
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          colId: 'cargoEnglishName',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.HsCode'),
          field: 'hsCode',
          colId: 'hsCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: 'costChargeInput',
          colId: 'costChargeInput',
          width: 150,
          filter: false,
          filterParams: {},
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.chargeInputLabelFunction(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.FreeDemurrage'),
          field: 'freeDemurrage',
          colId: 'freeDemurrage',
          width: 150,
          filterParams: {},
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.FreeDetention'),
          field: 'freeDetention',
          colId: 'freeDetention',
          width: 150,
          filterParams: {},
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('CargoMsg.Cargo_SpecialPriceInstructions'),
          field: 'salePriceRemarks',
          colId: 'salePriceRemarks',
          hide: true,
          width: 150
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'businessDate', colId: 'businessDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.Door'), field: 'doorNameStar', colId: 'doorNameStar', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.DoorAddress'), field: 'doorAddrStar', colId: 'doorAddrStar', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.DoorCity'), field: 'cityCodeStar', colId: 'cityCodeStar', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.WareHouseName'), field: 'truckWarehouseName', colId: 'truckWarehouseName', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.Driver'), field: 'driverName', colId: 'driverName', width: 200, enableRowGroup: true },
        { headerName: this.$t('SeaExport.ComprehensiveLogisticsOrderType'), field: 'containerLoadType', colId: 'containerLoadType', width: 200,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          }
        },
        { headerName: this.$t('SeaExport.ComprehensiveLogisticsTransportationType'), field: 'transportType', colId: 'transportType', width: 200, enableRowGroup: true },
        {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 100,
          enableRowGroup: true
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          hide: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ServiceCode'),
          field: 'vesselLineCode',
          colId: 'vesselLineCode',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.AirlineArea'),
          field: 'regionName',
          colId: 'regionName',
          hide: true,
          cellRenderer: (params) => {
            if (params.value && !this.isZh) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'name', params.value, 'nameEnglish')
            }
            return params.value
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: 'etd',
          colId: 'etd',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
          },
          width: 200,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CarrierAgent'),
          field: 'carrierAgentId',
          colId: 'carrierAgentId',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          },
          width: 200,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DateOfArrival2'),
          field: 'eta',
          colId: 'eta',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo',
          hide: true,
          width: 150,
          tooltipValueGetter: (params) => params.value,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.HarborDistrict'),
          field: 'portDistrict',
          colId: 'portDistrict',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CYOpeningTime'),
          field: 'terminalOpendate',
          colId: 'terminalOpendate',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.PortAreaCYCutOffTime'),
          field: 'terminalCutoff',
          colId: 'terminalCutoff',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PortCodeOfDischarge'),
          field: 'portCode',
          colId: 'portCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
          field: 'atd',
          colId: 'atd',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDateOfArrival2'),
          field: 'ata',
          colId: 'ata',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ArrivalTime'),
          field: 'actualArrivalTime',
          colId: 'actualArrivalTime',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          colId: 'chargeWeight',
          cellRenderer: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return ColumnUtils.number3ColumnLabelFunc(Number(params.value))
          },
          hide: true,
          width: 150,
          enableRowGroup: true,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          colId: 'warehouseNo',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.DestinationGatePoint'),
          field: 'doorNameEnd',
          colId: 'doorNameEnd',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.AddressOfDestinationGatePoint'),
          field: 'doorAddressEnd',
          colId: 'doorAddressEnd',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.DestinationGateCity'),
          field: 'cityCodeEnd',
          colId: 'cityCodeEnd',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.EstimatedPackingDate'),
          field: 'loadingDate',
          colId: 'loadingDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ActualPackingDate'),
          field: 'actLoadingDate',
          colId: 'actLoadingDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ExpectedArrivalDate2'),
          field: 'arriveDate',
          colId: 'arriveDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ActualArrivalDate'),
          field: 'actualArrivalDate',
          colId: 'actualArrivalDate',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
          field: 'dispatchingPlace',
          colId: 'dispatchingPlace',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'carrierId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
          field: 'actTakeTime',
          colId: 'actTakeTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          hide: !this.useOrderCenterMode,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          hide: !this.useOrderCenterMode,
          enableRowGroup: true
        }, { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: 'jobProfitShare', width: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          field: 'sopState',
          colId: 'sopState',
          width: 100,
          tooltipValueGetter: (params) => params.value,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
          field: 'trackingTemplateUuid',
          width: 180,
          colId: 'trackingTemplateUuid',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: 'specialApprovalDate', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          width: 180,
          hide: true,
          colId: 'incoTerm',
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateCsrCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterModes && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateDcCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
          colId: 'verifyStateReceivableDomestic',
          field: 'verifyStateReceivableDomestic',
          width: 140,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
          colId: 'verifyStateReceivableOversea',
          field: 'verifyStateReceivableOversea',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Auditor'),
          colId: 'fcAuditUser',
          field: 'fcAuditUser',
          width: 140,
          hide: true,
          valueGetter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.fcAuditUser, 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuditDate'),
          colId: 'fcAuditDate',
          field: 'fcAuditDate',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: 'businessLock', width: 100, colId: 'businessLock',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLockedStatusLabelFunc(stringToBool(params.value))
          },
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_transferPortCode'),
          colId: 'transferPortCode',
          field: 'transferPortCode',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 170,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
          colId: 'payableInvoiceState',
          field: 'payableInvoiceState',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.receivableInvoiceStateLabelFunction(params.data.payableInvoiceState),
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
          colId: 'receivableChargeLockedDate',
          field: 'receivableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
          colId: 'payableChargeLockedDate',
          field: 'payableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          colId: 'payableChargeLockedPerson',
          field: 'payableChargeLockedPerson',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
          colId: 'interestAmountCurrency',
          field: 'interestAmountCurrency',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CheckRuleResult'),
          colId: 'checkRuleResult',
          field: 'checkRuleResult',
          width: 100,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.CheckRuleResultLabelFun(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ConsignationRelationNumber'), field: 'trustFromJob', width: 180, colId: 'trustFromJob', enableRowGroup: true },
        { headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'), field: 'relatedJob', width: 180, colId: 'relatedJob', enableRowGroup: true },
        {
          headerName: this.$t('SeaExport.ExportControlledProducts'),
          field: 'exportControlledProduct',
          colId: 'exportControlledProduct',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ExportControlledProduct, 'code', params.value, 'chineseName') : ''
          },
          width: 120
        }
      ],
      rowData: [],
      gridApi: null,
      selectedRowIndex: -1,
      selectedRows: [],
      documentManage: new DocumentManage(),
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      stateDialog: {
        visible: false,
        rows: [],
        trackingList: []
      },
      customJobTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        customJobType: ''
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      statisticsDialog: {
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txt20: 0,
        txt40: 0,
        txt40hq: 0,
        txt45: 0,
        txtTeu: 0,
        txtWeight: 0.000,
        txtChargeWeight: 0.000,
        txtCubage: 0.000,
        txtdesignationAgentNum: 0,
        containShutOutJob: false
      },
      transshipDialog: {
        visible: false,
        jobKeys: [],
        selectedJobs: [],
        isDBFlag: true,
        txtVessel: '',
        txtVessel_1: '',
        txtVoyage: '',
        txtVoyage_1: '',
        dfETD: '',
        txtPortAgent: '',
        voyages: '',
        transship: {}
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new IntegratedJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      arSettlementUnitOptional: false,
      addChargeDetailDialog: {
        visible: false,
        type: 0,
        selectedScheme: [],
        selectedJobs: []
      },
      chargeTypeDialog: {
        visible: false,
        selectedJobs: [],
        type: 0
      },
      role: {
        addReceivableChargeRole: this.$checkPermission(['button_Charge_payAddCharge']),
        addPayableChargeRole: this.$checkPermission(['button_Charge_costAddCharge'])
      },
      editChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      deleteChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      exportOrderCommand: this.$t('SeaExport.Add'),
      importJobLobDialog: { // 导入业务类型选择弹窗
        visible: false,
        lob: 'IE'
      },
      JobUtils,
      currentRow: {},
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false
      },
      batchModifyBusinessDialog: {
        visible: false,
        jobList: [],
        jobKeys: [],
        lob: ''
      },
      changeSopTemplateDialog: {
        visible: false,
        jobList: []
      },
      batchCooperationDialog: {
        visible: false,
        jobList: []
      },
      gpExplain: {
        type: 'list',
        visible: false,
        jobUuids: []
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      isZY: false,
      defaultSearchItems: [],
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      perConfigName: '',
      gridRefreshId: 0,
      openMutualTrustConfig: false,
      instructioinBtns: [] // 指令按钮列表
    }
  },
  computed: {
    showAddHblButton() {
      const hideTypes = [
        SeaExportConstants.STUFFY_TT.code,
        SeaExportConstants.STUFFY_CL.code
      ]
      return !hideTypes.includes(this.integratedLogisticsType)
    },
    searchItemConfigModule() {
      return '2100'
    },
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    selectedRow() {
      if (this.gridApi) {
        let uuid
        this.gridApi.forEachNode(node => {
          if (node.data && this.selectedRowIndex === node.rowIndex) {
            uuid = node.data.uuid
          }
        })
        if (uuid) {
          let key
          this.rowData.map((item, index) => {
            if (item.uuid === uuid) {
              key = index
            }
          })
          return this.rowData[key]
        }
        return this.rowData[this.selectedRowIndex]
      } else {
        return this.rowData[this.selectedRowIndex]
      }
    },
    enableBtnSplit() {
      return this.selectedRows.findIndex(p => p.lclMasterUuid) >= 0
    },
    batchSelectFlag() {
      return this.selectedRows.length > 0
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    actionOrderUrl() {
      return URL.sys.importOrderTemplate
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.context.config ? Number(this.context.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.context.config ? Number(this.context.config.get('orderCenterBranch')) === 1 : false
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    isHQ() {
      return this.$store.getters.currentOfficeId === 1
    },
    conditonDisplayAllBranchData() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledViewDetail() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList && !this.hqViewAllDetail
    },
    validSingleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (!this.isZy && this.hierarchyViewDetail && this.selectedRow) {
          if (this.childOfficeIds.includes(this.selectedRow.opOffice) || this.childOfficeIds.includes(this.selectedRow.salesOffice)) {
            return true
          }
        }
        if (this.selectedRow && this.selectedRow.opOffice !== this.$store.getters.currentOfficeId && this.selectedRow.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.selectedRow.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.selectedRows) {
          if (!this.isZy && this.hierarchyViewDetail && row) {
            if (this.childOfficeIds.includes(row.opOffice) || this.childOfficeIds.includes(row.salesOffice)) {
              return true
            }
          }
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    },
    BatchModifyBusiness() {
      if (!this.integratedLogisticsType) {
        return !this.$checkPermission(['button_IEBooking_BatchUpdateJobInfo'])
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
        return !this.$checkPermission(['button_TTIEBooking_BatchUpdateJobInfo'])
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
        return !this.$checkPermission(['button_CLIEBooking_BatchUpdateJobInfo'])
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
        return !this.$checkPermission(['button_ICIEBooking_BatchUpdateJobInfo'])
      } else {
        return true
      }
    },
    addButtonPermission() {
      if (!this.integratedLogisticsType) {
        return 'button_IEBooking_addIEBooking'
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
        return 'button_TTIEBooking_addIEBooking'
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
        return 'button_CLIEBooking_addIEBooking'
      } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
        return 'button_ICIEBooking_addIEBooking'
      } else {
        return 'button_IEBooking_addIEBooking'
      }
    },
    finalColumnDefs() {
      if (this.$store.state.uiCustom.enable && this.integratedLogisticsType) {
        if (this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
          return UICustomUtil.handleColumnDefs(UICustomConstants.IC_BOOKING_MODULE, this.$store.getters.currentOfficeId, this.columnDefs)
        } else if (this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
          return UICustomUtil.handleColumnDefs(UICustomConstants.CL_BOOKING_MODULE, this.$store.getters.currentOfficeId, this.columnDefs)
        } else if (this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
          return UICustomUtil.handleColumnDefs(UICustomConstants.TT_BOOKING_MODULE, this.$store.getters.currentOfficeId, this.columnDefs)
        }
      }
      return this.columnDefs
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        if (this.hqViewAllList || this.hierarchyViewList) {
          this.customSearchItems = await this.getCustomSearchItems()
        }
        this.loadInstructionButtons()
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
    this.useOrderCenterModes = Number(this.context.config.get('useOrderCenterMode')) === 1
    this.allowPartialCheckPass = Number(this.context.config.get('allowPartialCheckPass')) === 1
    this.checkApChargeVerify = Number(this.context.config.get('PreCommitJobCheckApChargeStateVerify')) === 1
    this.useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
    this.chargeSchemeBatchDialog.chargeSchemeIsApproved = Number(this.context.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才
    this.salesCanSeeBookingAgent = Number(this.context.config.get('SalesCanSeeBookingAgent')) === 1
    this.isZY = String(this.context.config.get('ToExoSystem')) === 'zy'
    this.dataListDragGroup = Number(this.context.config.get('DataListDragGroup')) === 1
    this.openMutualTrustConfig = Number(this.context.config.get('openMutualTrustConfig')) === 2
    await this.initColumnDefs()
    this.init()
    this.loadInstructionButtons()
    if (this.isQuery) return
    this.queryLastModifyBookingByDay()
    if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
      this.columnDefs.push(
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'truckingPlateNumber',
          colId: 'truckingPlateNumber',
          width: 200,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNos',
          colId: 'sealNos',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CarryingCaseYard'),
          field: 'truckingPlaceOfDeps',
          colId: 'truckingPlaceOfDeps',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ReturnYard'),
          field: 'truckingPlaceOfDests',
          colId: 'truckingPlaceOfDests',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleNumberOne'),
          colId: 'destinationVehicleNumberOne',
          field: 'destinationVehicleNumberOne',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleRegister'),
          colId: 'destinationVehicleRegister',
          field: 'destinationVehicleRegister',
          width: 140,
          hide: true,
          enableRowGroup: true
        }
      )
    } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
      this.columnDefs.push(
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'truckingPlateNumber',
          colId: 'truckingPlateNumber',
          width: 200, enableRowGroup: true
        }
      )
    } else if (this.integratedLogisticsType && this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
      this.columnDefs.push(
        {
          headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
          field: 'khPlateNumber',
          colId: 'khPlateNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
          field: 'khTrailerNumber',
          colId: 'khTrailerNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_bargePlateNumber'),
          field: 'bargePlateNumber',
          colId: 'bargePlateNumber',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondPlateNumber'),
          field: 'secondPlateNumber',
          colId: 'secondPlateNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondTrailerNumber'),
          field: 'secondTrailerNumber',
          colId: 'secondTrailerNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khDeclareActTime'),
          colId: 'declareTime',
          field: 'declareTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khEntryActTime'),
          colId: 'actEntryTime',
          field: 'actEntryTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khExitActTime'),
          colId: 'actExitTime',
          field: 'actExitTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_transferDeclareCompletedActTime'),
          colId: 'declareCompletedTime',
          field: 'declareCompletedTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khReplacementActTime'),
          colId: 'actReplacementTime',
          field: 'actReplacementTime',
          width: 140,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_arrivePodActTime'),
          colId: 'actEnterPodTime',
          field: 'actEnterPodTime',
          width: 140,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_arriveClearActTime'),
          colId: 'actArriveClearTime',
          field: 'actArriveClearTime',
          width: 140,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khUnloadingActTime'),
          colId: 'actDischargeTime',
          field: 'actDischargeTime',
          width: 140,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleNumberOne'),
          colId: 'destinationVehicleNumberOne',
          field: 'destinationVehicleNumberOne',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleRegister'),
          colId: 'destinationVehicleRegister',
          field: 'destinationVehicleRegister',
          width: 140,
          hide: true,
          enableRowGroup: true
        }
      )
    } else {
      this.columnDefs.push(
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'truckingPlateNumber',
          colId: 'truckingPlateNumber',
          width: 200,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
          field: 'khPlateNumber',
          colId: 'khPlateNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
          field: 'khTrailerNumber',
          colId: 'khTrailerNumber',
          width: 120,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNos',
          colId: 'sealNos',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CarryingCaseYard'),
          field: 'truckingPlaceOfDeps',
          colId: 'truckingPlaceOfDeps',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ReturnYard'),
          field: 'truckingPlaceOfDests',
          colId: 'truckingPlaceOfDests',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_bargePlateNumber'),
          field: 'bargePlateNumber',
          colId: 'bargePlateNumber',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondPlateNumber'),
          field: 'secondPlateNumber',
          colId: 'secondPlateNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_secondTrailerNumber'),
          field: 'secondTrailerNumber',
          colId: 'secondTrailerNumber',
          hide: true,
          width: 100,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khDeclareActTime'),
          colId: 'declareTime',
          field: 'declareTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khEntryActTime'),
          colId: 'actEntryTime',
          field: 'actEntryTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khExitActTime'),
          colId: 'actExitTime',
          field: 'actExitTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_transferDeclareCompletedActTime'),
          colId: 'declareCompletedTime',
          field: 'declareCompletedTime',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleNumberOne'),
          colId: 'destinationVehicleNumberOne',
          field: 'destinationVehicleNumberOne',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationVehicleRegister'),
          colId: 'destinationVehicleRegister',
          field: 'destinationVehicleRegister',
          width: 140,
          hide: true,
          enableRowGroup: true
        }
      )
    }
    if (this.isZY) {
      this.columnDefs.push(
        {
          headerName: this.$t('CargoMsg.Cargo_ContainSensitiveWord'),
          colId: 'hasSensitiveWord',
          field: 'hasSensitiveWord',
          width: 130,
          minWidth: 130,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_SystemConstants$HAS_SENSIVITE_WORD, 'code', params.value, 'chineseName')
          }
        }
      )
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showBusinessInfo', function() {
      self.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: bookingTreeGridJS.methods
}
</script>

<style scoped lang="scss">
</style>
